/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlAppSchemasAsmEntityVulnerabilitiesCount } from './ControlAppSchemasAsmEntityVulnerabilitiesCount';
import {
    ControlAppSchemasAsmEntityVulnerabilitiesCountFromJSON,
    ControlAppSchemasAsmEntityVulnerabilitiesCountFromJSONTyped,
    ControlAppSchemasAsmEntityVulnerabilitiesCountToJSON,
} from './ControlAppSchemasAsmEntityVulnerabilitiesCount';

/**
 * 
 * @export
 * @interface ControlRiskHistoryVulnerabilityStats
 */
export interface ControlRiskHistoryVulnerabilityStats {
    /**
     * 
     * @type {ControlAppSchemasAsmEntityVulnerabilitiesCount}
     * @memberof ControlRiskHistoryVulnerabilityStats
     */
    criticality?: ControlAppSchemasAsmEntityVulnerabilitiesCount;
}

/**
 * Check if a given object implements the ControlRiskHistoryVulnerabilityStats interface.
 */
export function instanceOfControlRiskHistoryVulnerabilityStats(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlRiskHistoryVulnerabilityStatsFromJSON(json: any): ControlRiskHistoryVulnerabilityStats {
    return ControlRiskHistoryVulnerabilityStatsFromJSONTyped(json, false);
}

export function ControlRiskHistoryVulnerabilityStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlRiskHistoryVulnerabilityStats {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'criticality': !exists(json, 'criticality') ? undefined : ControlAppSchemasAsmEntityVulnerabilitiesCountFromJSON(json['criticality']),
    };
}

export function ControlRiskHistoryVulnerabilityStatsToJSON(value?: ControlRiskHistoryVulnerabilityStats | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'criticality': ControlAppSchemasAsmEntityVulnerabilitiesCountToJSON(value.criticality),
    };
}

